import { createSlice } from '@reduxjs/toolkit';

import { IInitialSiteState } from './types';

const SLICE_NAME = 'SITE_SLICE';

const initialState: IInitialSiteState = {
  data: null,
  loading: true,
  error: null,
  selectedSiteData : null,
  loadingSelectedSite : false,
  selectedSiteError : ''
};

const siteSlice = createSlice({
  name: SLICE_NAME,
  initialState: initialState,
  reducers: {
    fetchSiteError: (state) => {
      state.loading = false;
      state.error = 'error';
    },
    fetchSite: (state, { payload }) => {
      state.loading = true;
      state.error = '';
    },
    fetchSiteSuccess: (state, { payload }) => {
      state.loading = false;
      state.data = payload;
    },
    updateSiteNewIssues: (state, { payload }) => {
      state.loading = true;
    },
    updateSiteNewIssuesSuccess: (state) => {
      state;
    },

    // selected Site.
    selectedSiteSuccess: (state , { payload }) => {
      state.loadingSelectedSite = true;
      state.selectedSiteError = '';
      state.selectedSiteData = payload;
    },
    selectedSite: (state, { payload }) => {
      state.loadingSelectedSite = false;
      state.selectedSiteError = '';
    },
    selectedSiteError: (state) => {
      state.loadingSelectedSite = false;
      state.selectedSiteError = 'error';
    },
  },
});

export default siteSlice;
